// CreateRoleModal.js
import React from 'react'
import {Form, Input, Modal, Switch} from 'antd'
import useTranslate from 'modules/local/useTranslate'

const CreateRoleModal = ({open, onCancel, onSubmit, loading}) => {
    const t = useTranslate()
    const [form] = Form.useForm()

    const handleOk = () => {
        form.validateFields().then((values) => {
            onSubmit && onSubmit(values)
        })
    }

    const handleCancel = () => {
        form.resetFields()
        if (onCancel) onCancel()
    }

    const handleAfterClose = () => {
        form.resetFields()
    }

    return (
        <Modal
            className="custom-modal"
            open={open}
            title={
                <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                    {t('create role')}
                </div>
            }
            okText={t('create')}
            cancelText={t('cancel')}
            onOk={handleOk}
            onCancel={handleCancel}
            afterClose={handleAfterClose}
            confirmLoading={loading}
            width={440}
            destroyOnHidden>

            <Form form={form} layout="vertical">
                <div className="mt-4 p-4 space-y-6">

                    {/* Tên vai trò */}
                    <Form.Item
                        name="name"
                        label={
                            <span className="text-sm font-medium text-color-200 tracking-wider pr-3">
                                {t('role name')}
                            </span>
                        }
                        rules={[
                            {required: true, message: t('role name is required')},
                            {min: 2, message: t('min 2 characters')},
                            {max: 100, message: t('max 100 characters')},
                        ]}
                        className="mb-0">
                        <Input
                            placeholder={t('e.g. Finance Committee')}
                            autoFocus
                            autoComplete="off"
                            className="rounded-lg"
                        />
                    </Form.Item>

                    {/* Trạng thái */}
                    <div className="flex items-center justify-between pb-1">
                        <span className="text-sm font-medium text-color-200 tracking-wider pr-3">
                            {t('active')}
                        </span>
                        <Form.Item name="active" valuePropName="checked" initialValue={true} noStyle>
                            <Switch/>
                        </Form.Item>
                    </div>

                </div>
            </Form>
        </Modal>
    )
}

export default CreateRoleModal